import { Avatar, IconButton, Stack } from "@mui/material";
import { useSSAuth } from "../hooks/useSSAuth";
import { SSText } from "src/components/base/components/SSText";
import { crc32, formatUSPhoneNumberWithBracket } from "src/utils/utils";
import { FiEdit } from "react-icons/fi";
import { useUpdateProfileModal } from "./GlobalModals/UpdateProfileModal";
import { useTeamConfig } from "./TeamConfigProvider";
import { constants } from "src/shared/constants";
import { useEffect, useState } from "react";

export function UserProfile() {
  const { getUserData } = useSSAuth();
  const user = getUserData();
  const useUpdateProfileModalState = useUpdateProfileModal();
  const { VENDOR, TEAM_GLOBAL_SETTINGS } = useTeamConfig();
  const [accountId, setAccountId] = useState<string | undefined>(user?.accountId); // prettier-ignore

  useEffect(() => {
    if (VENDOR === constants.vendorUUIDs.seatgeek && user?.accountId)
      setAccountId(String(crc32(user?.accountId)));
  }, []);

  return (
    <Stack alignItems={"center"}>
      {!TEAM_GLOBAL_SETTINGS?.NAV_MENU?.HIDE_AUTH_BUTTONS ? (
        <Avatar
          sx={{
            width: 64,
            height: 64,
          }}
        >
          {user?.firstName[0]}
          {user?.lastName[0]}
        </Avatar>
      ) : null}

      <Stack alignItems={"center"}>
        {!TEAM_GLOBAL_SETTINGS?.NAV_MENU?.HIDE_AUTH_BUTTONS ? (
          <SSText variant="h5" fontWeight={"600"} mt={1.5}>
            {user?.firstName}
          </SSText>
        ) : null}
        <SSText variant="body">{user?.email}</SSText>
        <SSText>Account ID: {accountId}</SSText>
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <SSText>{formatUSPhoneNumberWithBracket(user?.phoneNumber)}</SSText>
          <IconButton
            onClick={() => useUpdateProfileModalState.set({ isOpen: true })}
          >
            <FiEdit fontSize={"18px"} />
          </IconButton>
        </Stack>
      </Stack>
    </Stack>
  );
}
